// Trigger names the Agents page deliberately keeps out of its trigger rail.
// "Message Created" was superseded by the dedicated message-agent triggers
// (Pro Message Received / Guest Message Received) in Apr 2026, but the BE
// still returns it in the trigger catalog, so pre-existing workflows built on
// it remain and still fire.
//
// Anything listed here is unreachable on the Agents page, so surfaces that
// deep-link into that page (e.g. the per-page agent indicator) must exclude it
// too — otherwise they advertise agents that cannot be opened.
export const HIDDEN_AGENT_TRIGGER_NAMES = ['message created'];

export function isHiddenAgentTrigger(triggerName?: string | null): boolean {
  return HIDDEN_AGENT_TRIGGER_NAMES.includes((triggerName || '').trim().toLowerCase());
}
